// Hand-mirrors the api's InsightFormatter response shape (innerhive-api api/src/insights/InsightFormatter.ts)
// — there is no shared package for this type, so changes must be made in lockstep in both repos.
import { ILink } from '../caremap/WithLinks';

export type InsightType = 'trend' | 'anomaly' | 'recommendation' | 'gap';
export type InsightConfidence = 'low' | 'medium' | 'high';
export type InsightVisibility = 'care-map' | 'private';

// One per wedge of the wellbeing hexagon. Mirrors CARE_DOMAINS in the api's
// api/src/insights/careDomains.ts.
export type CareDomain = 'rest' | 'eating' | 'mood' | 'comfort' | 'connection' | 'clarity';

// The mediaType InsightsModel requests/sends and the api's InsightFormatter returns.
export const insightMediaType = 'application/vnd.innerhive.insight.v1+json';

export interface IInsightEvidence {
    ref: string;      // contentAddress-format ref (see insightRef.ts's parseInsightRef)
    date: string;      // ISO date of the evidence item
    snippet: string;   // short human-readable excerpt/title
}

export interface IInsightFeedback {
    helpful: boolean;
    note?: string;
    at: string;
}

// Mirrors the api's insight response shape (api/src/insights/InsightFormatter.ts's formatForResponse).
// The api's own IInsight (api/src/insights/model.ts) additionally carries scopeKey/seenBy/dismissedBy/
// feedback, but the formatter strips those before the response reaches the app, folding seenBy/
// dismissedBy/feedback into isSeen/isDismissed/myFeedback below.
export interface IInsight {
    careMapKey: string;
    insightId: string;
    visibility: InsightVisibility;
    type: InsightType;
    title: string;
    narrative: string;
    // Absent on insights written before reflection assigned domains.
    domains?: CareDomain[];
    evidence: IInsightEvidence[];
    confidence: InsightConfidence;
    dateRangeFrom: string;
    dateRangeTo: string;
    generatedBy: string;
    active: boolean;
    invalidatedReason?: string;
    createdAt: string;
    pushedAt?: string;
    isSeen: boolean;
    isDismissed: boolean;
    myFeedback?: IInsightFeedback;
    links: {
        seen: ILink;
        dismissed: ILink;
        feedback: ILink;
    };
}
